export default "__VITE_ASSET__DvJVv2zO__"